/*
 * File: \src\containers\organization\theme\index.js
 * Project: web
 * File Created: Tuesday, 24th March 2020 1:01:27 am
 */

import loadable from '@loadable/component'

export default loadable(() => import('./Theme'))
